import { globalAxiosInstance } from "../../../apiCalls/utils/axios";
import { makeRequest } from "../../../apiCalls/utils/makeRequest";
import { VehicleTemplateColumn } from "../typings/VehicleTemplateColumn";
import { OdometerSource } from "../typings/RawVehicleTemplate";

type CreateVehiclesTemplatesRequest = {
  template: {
    name: string;
    description: string;
    isDefaultTemplate: boolean;
    ignitionValue: string;
    columns: VehicleTemplateColumn[];
    tags: string[];
    companies: string[];
    owner: string;
    displayColumns: string[] | null;
    errorCodesMappingName: string | null;
    internalTariffId: string | null;
    odometerSource: OdometerSource;
  };
};

export const useCreateVehicleTemplates = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  buildQuery: () => "/vehicles/templates",
  axiosInstance: globalAxiosInstance,
  method: "post",
  buildData: ({ template }: CreateVehiclesTemplatesRequest) => ({
    name: template.name,
    description: template.description,
    all_columns: template.columns.reduce(
      (prev, column) => ({
        ...prev,
        [column.technicalName]: {
          name: column.name,
          has_hover: column.hasHover,
          hover: column.hover,
          default: column.default,
          unit: column.unit,
          scale_factor: column.scale_factor,
          digits_after_comma: column.digits_after_comma,
          values_mapping_name: column.values_mapping_name,
          type: column?.type,
        },
      }),
      {},
    ),
    default_columns: template.columns
      .filter((column) => column.isDefault)
      .map(({ technicalName }) => technicalName),
    ignition_value: template.ignitionValue,
    is_digital: template.columns
      .filter((column) => column.isDigital)
      .map(({ technicalName }) => technicalName),
    tags: template.tags,
    companies: template.companies,
    owner: template.owner,
    is_default_template: template.isDefaultTemplate,
    display_columns: template.displayColumns,
    error_codes_mapping_name: template.errorCodesMappingName || null,
    internal_tariff_id: template.internalTariffId || null,
    odometer_source: template.odometerSource,
  }),
});
